import { useNewBuild } from "../../context/NewBuildContext";

/**
 * 머리 줄의 「업데이트」 버튼 — 새 버전이 나왔을 때만 선다(평소엔 헤더 폭을 안 먹는다).
 *
 * 누르면 곧바로 새로고침해 새 버전으로. 안 눌러도 다른 화면으로 옮기는 순간 저절로 바뀐다
 * (NewBuildContext — 보고 있는 화면은 저절로 새로고침하지 않으므로, 가만히 볼 때 바꾸는 길이 이 버튼이다).
 * 창(role="dialog"·.modal)이 아니다 — 창이면 «떠 있는 창이 있다» 판정에 자기가 걸려 자동 갈아타기가 영영 미뤄진다.
 * 선택 이용(외부용) 화면에도 그대로 보인다 — 우리 내부 데이터가 아니라 앱을 쓰는 데 필요한
 * 최소한(옛 코드로 계속 쓰면 터진다)이기 때문이다.
 */
export default function NewBuildHeaderButton({ className = "" }: { className?: string }) {
  const { available, reload } = useNewBuild();
  if (!available) return null;

  return (
    <button
      type="button"
      onClick={reload}
      data-testid="new-build-update-button"
      data-activity-name="새 버전 업데이트"
      title="새 버전이 나왔어요 — 누르면 바로 바뀝니다. 다른 메뉴로 옮기셔도 저절로 바뀝니다."
      aria-label="새 버전으로 업데이트"
      className={`relative flex h-9 shrink-0 items-center gap-1.5 whitespace-nowrap rounded-lg bg-brand-500 px-3 text-xs font-semibold text-white shadow-theme-xs transition hover:bg-brand-600 ${className}`}
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="h-4 w-4"
      >
        <path d="M21 12a9 9 0 1 1-3-6.7" />
        <path d="M21 3v6h-6" />
      </svg>
      업데이트
      <span className="absolute -right-1 -top-1 flex h-2.5 w-2.5">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-orange-400 opacity-75" />
        <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-orange-500 ring-2 ring-white dark:ring-gray-900" />
      </span>
    </button>
  );
}
